<template>
  <section class="materials">
    <div class="material">
      <div>
        <h2>Sticker</h2>
        <ul>
          <li>
            Hecht aan ieder oppervlak
          </li>
          <li>
            Verwijderbaar zonder lijmresten (binnen 3 maanden)
          </li>
        </ul>
      </div>

      <img class="sticker" src="@/images/pages/sticker.svg" />
    </div>

    <div class="material">
      <div>
        <h2>Vloersticker</h2>
        <ul>
          <li>
            Slijtvaste afbeelding
          </li>
          <li>
            Anti-slip
          </li>
          <li>
            Extra hoge kleefkracht
          </li>
        </ul>
      </div>

      <img class="vloersticker" src="@/images/pages/vloersticker.svg" />
    </div>

    <div class="material">
      <div>
        <h2>Magneetsticker</h2>
        <ul>
          <li>
            Magnetische folie
          </li>
          <li>
            Makkelijk te verwijderen
          </li>
          <li>
            Herbruikbaar
          </li>
        </ul>
      </div>

      <img class="magneet" src="@/images/pages/magneetsticker.svg" />
    </div>

    <div class="material">
      <div>
        <h2>Reflecterende sticker</h2>
        <ul>
          <li>
            Veiligheidsklasse 3
          </li>
          <li>
            Geschikt voor buitengebruik
          </li>
          <li>
            Permanent hechtend
          </li>
        </ul>
      </div>

      <img class="magneet" src="@/images/pages/reflecterende-sticker.svg" />
    </div>

    <div class="material">
      <div>
        <h2>Forex</h2>
        <ul>
          <li>
            Bord van gerecycled kunststof
          </li>
          <li>
            Licht in gewicht
          </li>
          <li>
            Enigszins buigzaam
          </li>
          <li>
            Geschikt voor buitengebruik (tot ca. 1 jaar)
          </li>
        </ul>
      </div>

      <img class="forex" src="@/images/pages/forex.svg" />
    </div>

    <div class="material">
      <div>
        <h2>Dibond</h2>
        <ul>
          <li>
            Aluminium sandwichpaneel
          </li>
          <li>
            Licht in gewicht
          </li>
          <li>
            Extra stevig, vormvast
          </li>
          <li>
            Geschikt voor langdurig buitengebruik
          </li>
        </ul>
      </div>

      <img class="dibond" src="@/images/pages/dibond.svg" />
    </div>
  </section>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.materials {
  flex-wrap: wrap;
  justify-content: space-between;
  display: flex;
  text-align: left;
}

.material {
  width: 100%;
  border-radius: 10px;
  box-shadow: #00000020 0 0 45px -9px;
  padding: 20px 30px;
  margin-bottom: 20px;
  background: white;
  display: flex;

  h2 {
    font-size: 16px;
    color: #002169;
    margin: 10px 0 0;
    font-weight: 400;
  }

  ul {
    list-style-type: disc;
    list-style-position: outside;
    padding: 10px 0 10px 16px;
  }

  img {
    flex: 0 0 auto;
    &.sticker {
      width: 87px;
    }

    &.vloersticker {
      width: 106px;
    }

    &.magneet {
      width: 108px;
    }

    &.forex {
      width: 112px;
    }

    &.dibond {
      width: 110px;
    }
  }

  div {
    flex-grow: 1;
  }

  @media only screen and (min-width: 768px) {
    width: calc(50% - 10px);
  }
}
</style>
